<template>
  <v-list-group
    v-model="folderLocal.opened"
    :value="groupId"
    @click.stop.prevent="handleToggle"
    transition="slide-y-transition"
    no-action
  >
    <template #activator="{ props }">
        <v-list-item v-bind="props">
        <template v-slot:prepend>
            <img v-if="functionIcon.has(folder.folderName)" :src="functionIcon.get(folder.folderName)"
                class="istore-func-folder-icon" alt=""/>
            <img v-else src="@/assets/icons/folder-outline.svg" class="istore-func-folder-icon" alt=""/>
        </template>
        {{ folder.folderDisplayName === folder.folderName && !folder.hasTempInTree
          ? `folder.level${folder.folderLevel}.${folder.folderName}`
          : folder.folderDisplayName
        }}
        </v-list-item>
    </template>

    <!-- Functions inside this folder -->
    <v-list-item
      v-for="(func, funcIdx) in folder.functions"
      :key="'func-' + depth + '-' + funcIdx"
      :class="{ 'istore-func-bg-active': isActive(func) }"
      @click.prevent="handleGoto(func)"
    >
        <v-icon icon="mdi-blank" size="x-small"></v-icon>
        {{ func.displayName === func.name ? `${func.module}.${func.name}` : func.displayName }}
    </v-list-item>
    <!-- Recurse into subfolders -->
    <IStoreSidebarNavRecursive
      v-for="(subFolder, subIdx) in folder.folders"
      :key="'subfolder-' + depth + '-' + subIdx"
      :folder="subFolder"
      :depth="depth + 1"
      @goto="handleGoto"
      @toggle-folder="handleToggle"
    />
  </v-list-group>
</template>

<script>
import icon_admin from '@/assets/images/function/icon_admin.svg'
import icon_dashboard from '@/assets/images/function/icon_dashboard.svg'
import icon_department from '@/assets/images/function/icon_department.svg'
import icon_phone from '@/assets/images/function/icon_phone.svg'
import icon_report from '@/assets/images/function/icon_report.svg'
import icon_starise from '@/assets/images/function/icon_starise.svg'
import icon_system from '@/assets/images/function/icon_system.svg'

export default {
  name: 'IStoreSidebarNavRecursive',
  props: {
    folder: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      folderLocal: { ...this.folder }, // shallow copy to avoid mutating props
      functionIcon: new Map(),
      functionItemIcon: new Map(),
    };
  },
  created() {

    this.functionIcon.set('icon_dashboard', icon_dashboard)
    this.functionIcon.set('icon_department', icon_department)
    this.functionIcon.set('pbx', icon_phone)
    this.functionIcon.set('icon_report', icon_report)
    this.functionIcon.set('system', icon_system)
    this.functionIcon.set('concioSystem', icon_starise)
    this.functionIcon.set('ai', icon_dashboard)
    this.functionIcon.set('inodePlugin', icon_admin)
    this.functionIcon.set('concio', icon_system)
    this.functionIcon.set('report', icon_report)

  },
  methods: {
    handleGoto(func) {
      this.$emit('goto', func);
    },
    handleToggle(event) {
      this.$emit('toggle-folder', event, this.folder);
    },
    isActive(func) {
      if (this.$store.state.currentMenu) {
        return func.parent === this.$store.state.currentMenu.parent
          && func.module === this.$store.state.currentMenu.module
          && func.name === this.$store.state.currentMenu.name
      }
      return false
    }
  },
  components: {
    IStoreSidebarNavRecursive: () => import('./IStoreSidebarNavRecursive.vue')
  },
  computed: {
    groupId() {
      return `folder-${this.depth}-${this.folder.folderName}`
    }
  }
};
</script>
